/**
 * Top-level `params` keys, per action type, that may read the payload a
 * partner module emitted, through `{{event.*}}`. A payload never fills a URL,
 * route or step target, so no entry may name one; a test fails when one does.
 *
 * No existing action takes a payload, so this is empty. The first entry
 * arrives with the action that stores a payload and goes through architecture
 * review. Dynamic Flows holds the same table in
 * `application/config/HostSlotOutputActions.ts` and refuses the same bindings
 * at publish time. Keep the two in lockstep.
 */
export const PAYLOAD_SAFE_PARAMS: Readonly<Record<string, readonly string[]>> =
  Object.freeze({});
